import { render, staticRenderFns } from "./PreviewImageArea.vue?vue&type=template&id=6528a5c2&scoped=true&"
import script from "./PreviewImageArea.vue?vue&type=script&lang=ts&"
export * from "./PreviewImageArea.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewImageArea.vue?vue&type=style&index=0&id=6528a5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528a5c2",
  null
  
)

export default component.exports